import React, { useState, useEffect } from "react";
import "../../../stylesheet/component.css";
import logo from "../../../images/logo_sum.png";

const Summary = ({ data, divRef }) => {
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000); // Update every second

    return () => {
      clearInterval(interval);
    };
  }, []);

  const formattedDate = `${currentDate
    .getDate()
    .toString()
    .padStart(2, "0")}/${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${currentDate.getFullYear()}`;
  const calculateDuration = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const durationInDays = Math.floor((end - start) / (1000 * 60 * 60 * 24));

    if (durationInDays >= 14) {
      const weeks = Math.floor(durationInDays / 7);
      return weeks > 1 ? `${weeks} weeks` : "1 week";
    } else if (durationInDays >= 7) {
      return "1 week";
    } else if (durationInDays > 0) {
      return `${durationInDays} days`;
    } else {
      return "0 days";
    }
  };

  return (
    <div ref={divRef} className="summary overflow-hidden overflow-x-auto">
      <div className="sum_head">
        <h2>Prescription ID: PC/06-0012</h2>
        <h2>
          <span>Dr. John Doe </span>{" "}
          <p>
            Bethel Care Centre <br />
            Resident Doctor In Charge <br />
            MD 25340{" "}
          </p>
        </h2>
      </div>
      <table className="table-fixed w-full text-[0.8rem] min-w-[700px]">
        <thead className="text-left">
          <tr >
            <th className="border-2 border-[#009FE3] pl-2 ">Patient ID: PC-0083</th>
            <th colSpan={2} className="border-2 border-[#009FE3] pl-2"> Name: <span>{data.patient.name ?? data.patient.patientName} </span></th>
            <th className="border-2 border-[#009FE3] pl-2"> Age: <span>{data.patient.age}yrs</span></th>
            <th className="border-2 border-[#009FE3] pl-2">
              Date: <span>{formattedDate}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr colSpan="2">
            <td className="divide-y pl-2 cont">
              <h2 className="mt-6">Chief Complainant</h2>
              <p>{data.patient.complaints}</p></td>
            <td colSpan={4} rowSpan={2} className="border-l border-[#009FE3]">
              <table className="w-full ">
                <tbody>
                  <tr>
                    <td className="text-left p-" colSpan={1}>
                      <div className="p-3">
                        <img src={logo} alt="" className="h-[36px] w-[36px]" />
                      </div>
                    </td>
                    <td className="text-right font-mono" colSpan={1}>
                      <p>mg or ml.</p>
                    </td>
                    <td colSpan={2} className="text-white">
                      &nbsp; hello
                    </td>
                  </tr>
                  {data.drugs.map((drug, index) => (

                    <tr className="font-mono" key={index}>
                      <table className="w-full ml-10 border-r border-[#009FE3]">
                        {/* <tbody> */}
                        <tr className="my-4">
                          <td colSpan={2} className="my-4">
                            <h3 className="my-4">
                              <p>{drug.med_name}</p>
                            </h3>
                          </td>
                          <td colSpan={2} className="my-4">
                            <p className="text-right px-2" >
                              {/* {drug.recommendedDosage}
                              {drug.consumptionFrequency} */}
                              {/* {drug.intakeQuantity}
                              {drug.intakeMeasurement} */}
                              {drug.recommendedDosage} -
                              {drug.intakeQuantityMeasurement || '...'}
                            </p>
                          </td>
                        </tr>
                        <tr className="sum_details my-4">
                          <td className="my-4 border-b pb-1" colSpan={3}>
                            <ul>


                              <li> {drug.intakeQuantity}
                              </li>
                              <li> {drug.intakeMeasurement} (s)</li>
                              <li>
                                {drug.mealTiming === "before_meal"
                                  ? "Before meal"
                                  : "After meal"}
                              </li>
                              <li>{calculateDuration(drug.startDate, drug.endDate)}</li>
                            </ul>
                          </td>
                        </tr>

                      </table>

                    </tr>
                  ))}

                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td className="divide-y pl-2 cont">
              <h2 className="mt-6">Investigation</h2>
              <p>{data.patient.examination}</p></td>
          </tr>
          <tr>
            <td className="divide-y pl-2 cont">

              <h2 className="mt-6">Diagnosis</h2>
              <p>{data.patient.diagnosis}</p>
            </td>
            {/* <td>Earth, Wind, and Fire</td>
            <td>1975</td> */}
          </tr>
        </tbody>
      </table>

    </div>
  );
};

export default Summary;
